import { render, staticRenderFns } from "./contact-card.vue?vue&type=template&id=8a73dcf4&scoped=true"
import script from "./contact-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./contact-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./contact-card.vue?vue&type=style&index=0&id=8a73dcf4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a73dcf4",
  null
  
)

export default component.exports